(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('fls-product-layout')) {
    customElements.define('fls-product-layout', class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        if (!this.section) return;
        this.observer = new MutationObserver(() => this.alignSizeChart());
        this.alignSizeChart();
        this.observer.observe(this.section, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      alignSizeChart() {
        const info = this.section.querySelector('.product-info__block-list');
        if (!info) return;
        const stock = info.querySelector('.red-div');
        const chart = info.querySelector('.best-fit-size-chart');
        if (!stock || !chart || stock.contains(chart) || !chart.querySelector('.scr-open-size-chart')) return;
        const source = chart.closest('.product-info__block-item');
        stock.classList.add('fls-stock-size-row');
        stock.append(chart);
        if (source && !source.contains(stock)) source.classList.add('fls-size-chart-source');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
